import { Sparkles } from "lucide-react";
import { EchelleTemperature } from "@/components/commun";

export default function Bientot({ titre, lot, texte }) {
  return (
    <div data-testid="page-bientot">
      <h1 className="text-4xl sm:text-5xl font-bold tracking-tight" data-testid="page-title">{titre}</h1>
      <div className="at-card p-6 md:p-10 mt-6 max-w-2xl">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 at-pill text-sm font-semibold" style={{ background: "var(--glow)" }}>
          <Sparkles size={15} />Bientôt disponible · lot {lot}
        </span>
        <p className="text-lg md:text-xl font-semibold mt-5 leading-snug">{texte}</p>
        <div className="mt-8 max-w-sm"><EchelleTemperature /></div>
      </div>
    </div>
  );
}
